import './ui';
var formAsync = require('./_formAsync');
var formSubmitDisable = require('./_formSubmitDisable');
var pwdStrength = require('./_pwdStrength');

//var zxcvbn = require('zxcvbn');


//import zxcvbn from '../../node_modules/zxcvbn/dist/zxcvbn.js';
if($('#loginBody').length) {
		$('#username').focus();
		$('#fos_user_resetting_form_plainPassword_first').focus();
	}

$('#loginForm').on('submit', function (e) {
	formSubmitDisable($(this),e,$('#submit'));
});

$('form.async').on('submit', function (e) {
	formAsync($(this), e);
});

$('form.submit-disable').on('submit', function (e) {
	formSubmitDisable($(this),e,$('#submit_' + $(this).attr('id')));
});

pwdStrength($('#fos_user_resetting_form_plainPassword_first'));

$('#showPwdFirst').on('keyup', function(){
	var pwd = $('#' + $(this).data('ref'));
	pwd.val($(this).val());
});

$('#showPwdSecond').on('keyup', function(){
	var pwd = $('#' + $(this).data('ref'));
	pwd.val($(this).val());
});

$('#doTogglePwd').on('click', function() {
	var txt1 = $('#showPwdFirst'),
	txt2 = $('#showPwdSecond'),
	pwd1 = $('#' + txt1.data('ref')),
	pwd2 = $('#' + txt2.data('ref'));
	if(txt1.hasClass('hidden')) {
		txt1.val(pwd1.val()).removeClass('hidden');
		txt2.val(pwd2.val()).removeClass('hidden');
		pwd1.addClass('hidden');
		pwd2.addClass('hidden');
	} else {
		txt1.addClass('hidden');
		txt2.addClass('hidden');
		pwd1.removeClass('hidden');
		pwd2.removeClass('hidden');
	}
});
